import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type Ajax from "cc-frontend/services/ajax"

interface Args {
  order: number
  closeModal: Function
  model: {
    userId: string
  }
}

export default class DubReferrals extends Component<Args> {
  @service declare ajax: Ajax

  @tracked embedToken: string | null = null
  @tracked isLoading = true
  @tracked error: string | null = null

  constructor(owner: unknown, args: Args) {
    super(owner, args)
    this.loadEmbedToken()
  }

  get embedUrl() {
    if (!this.embedToken) return null
    return `https://app.dub.co/embed/referrals?token=${encodeURIComponent(this.embedToken)}`
  }

  @action
  async loadEmbedToken() {
    try {
      const response = await this.ajax.request("/api/v4/dub/embed_token", {
        method: "GET",
      })
      if (response.error) {
        this.error = "Unable to load referral program. Please try again later."
      } else {
        this.embedToken = response.token
      }
    } catch (e) {
      this.error = "Unable to load referral program. Please try again later."
    } finally {
      this.isLoading = false
    }
  }
}
